/**
 * Grayscale chart theme for RS tenant — distinct series using shades of #2a2a2a.
 */

export const RS_CHART_BASE = '#2a2a2a';

/** Multi-series / domain bars (distinct but monochrome). */
export const RS_CHART_SERIES = [
  '#2a2a2a', '#3d3d3d', '#525252', '#6b6b6b', '#858585',
  '#9e9e9e', '#b0b0b0', '#c4c4c4', '#1a1a1a', '#474747',
];

/** Donut / distribution groups (inner ring). */
export const RS_CHART_GROUP = [
  '#2a2a2a', '#4a4a4a', '#6e6e6e', '#929292', '#b5b5b5', '#d4d4d4',
];

/** Nested operations (outer ring) — more steps. */
export const RS_CHART_OPERATION_NESTED = [
  '#1a1a1a', '#242424', '#2a2a2a', '#333333', '#3d3d3d', '#474747',
  '#525252', '#5c5c5c', '#666666', '#707070', '#7a7a7a', '#858585',
];

/** Line / area primary gradient (replaces blue rgba(17,98,212,...)). */
export function rsLineAreaGradient(ctx, chartArea) {
  if (!chartArea) return 'rgba(42, 42, 42, 0.12)';
  const g = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
  g.addColorStop(0, 'rgba(42, 42, 42, 0.4)');
  g.addColorStop(0.5, 'rgba(42, 42, 42, 0.1)');
  g.addColorStop(1, 'rgba(42, 42, 42, 0.03)');
  return g;
}

/** RS workflow statuses — line chart (border + fill base for gradients). */
export const RS_CHART_STATUS_LINE = {
  TO_DO: { border: '#1a1a1a', bg: 'rgba(26, 26, 26, 0.35)' },
  QUALIFIED: { border: '#232323', bg: 'rgba(35, 35, 35, 0.35)' },
  IN_PROGRESS: { border: '#2a2a2a', bg: 'rgba(42, 42, 42, 0.35)' },
  SOURCED: { border: '#3d3d3d', bg: 'rgba(61, 61, 61, 0.35)' },
  TO_PROPOS: { border: '#474747', bg: 'rgba(71, 71, 71, 0.35)' },
  PROPOSED: { border: '#4f4f4f', bg: 'rgba(79, 79, 79, 0.35)' },
  PRESENTED: { border: '#616161', bg: 'rgba(97, 97, 97, 0.35)' },
  FINAL: { border: '#737373', bg: 'rgba(115, 115, 115, 0.35)' },
  COMPLETED: { border: '#858585', bg: 'rgba(133, 133, 133, 0.4)' },
};

/** Legend / inline labels for RS status breakdown (matches RS_CHART_STATUS_LINE). */
export const RS_CHART_STATUS_LEGEND = {
  TO_DO: { label: 'To do', color: '#1a1a1a' },
  QUALIFIED: { label: 'Qualified', color: '#232323' },
  IN_PROGRESS: { label: 'In progress', color: '#2a2a2a' },
  SOURCED: { label: 'Sourced', color: '#3d3d3d' },
  TO_PROPOS: { label: 'To Propos', color: '#474747' },
  PROPOSED: { label: 'Proposed', color: '#4f4f4f' },
  PRESENTED: { label: 'Presented', color: '#616161' },
  FINAL: { label: 'Final', color: '#737373' },
  COMPLETED: { label: 'Completed', color: '#858585' },
};

/** Dual-axis top-operations chart: primary bar + secondary metric. */
export const RS_CHART_DUAL_BAR = { primary: '#2a2a2a', secondary: '#6b6b6b' };

/** Global performance: two lines (badges vs points). */
export const RS_CHART_GLOBAL_LINES = { a: '#2a2a2a', b: '#6b6b6b' };

/** Employee performance: "You" line accent (vs neutral team avg). */
export const RS_CHART_PERF_USER = '#2a2a2a';
